/* eslint-disable @typescript-eslint/camelcase */
import * as React from 'react'
import './styles.scss'

// export default class AppPromo extends React.Component {
// @ts-ignore
/**
 * @param {object} props
 * @param {string} props.url
 * @param {React.Node} props.text
 * @param {string} props.linktext
 * @param {string} props.waypoint
 * @returns {*}
 */
export default ({ url, text, linktext }) => {
  return (
    <div className='ui vertical fitted segment app-promote'>
      <img className='talogo' src={require('./tagesanzeiger.svg')} />
      <div className='textcontainer'>
        {text}
        <p>
          <a
            className='appPromButton'
            href={url}
            onTouchStart={() => {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'app_promo'
              })
            }}
          >
            {linktext}
          </a>
        </p>
      </div>
    </div>
  )
}
